<div class="customer-wrapper">
  <!-- Section - customer profile -->
  <section class="customer-profile pd-inline">
    <iu-customer-profile [data]="customer" (editButtonEmitter)="goToEditCustomer()" />
  </section>
  <!-- Section - customer profile -->

  <!-- Section - badge buttons -->
  <section class="badges pd-inline">
    <div class="badges-container">
      @for (badge of badges; track i; let i = $index) {
        <iu-badge-button [data]="badge" (clickEmitter)="badgeButtonClick(i)" />
      }
    </div>
    @if (lastRefreshData) {
      <div class="last-refresh">
        @if (isSync) {
          <span>{{ 'specificWindow.customer360.lastRefresh' | translate }} {{ lastRefreshData }}</span>
        } @else {
          <span class="not-sync-data" (click)="syncData()">
            {{ 'specificWindow.customer360.dataNotSync' | translate }}
            <i aria-hidden="true" class="icon-refresh3x"></i>
          </span>
        }
      </div>
    }
  </section>
  <!-- Section - badge buttons -->

  <!-- Section - quick actions -->
  <section class="quick-actions pd-inline">
    <div>
      @for (qa of quickActions; track $index) {
        <iu-quick-action [data]="qa" />
      }
    </div>
    <div>
      @for (qa of quickActionsProcess; track $index) {
        <iu-quick-action [data]="qa" (clickEmitter)="doQuickActionProcess($event)" />
      }
    </div>
  </section>
  <!-- Section - quick actions -->

  <!-- Section - statistics cards -->
  <section class="statistics">
    @for (stats of statistics; track $index) {
      <iu-statistics-card [stats]="stats" />
    }
  </section>
  <!-- Section - statistics cards -->

  <!-- Section - Text fields -->
  <section class="text-fields pd-inline pd-block">
    @for (textfield of textFields; track $index) {
      <iu-text-field-ui
        [container]="this"
        [data]="textfield.field"
        [fieldType]="'I'"
        [formatter]="textfield.formatter"
        [loadingAnimationTimeout]="1250"
        [ngClass]="{ 'col-1': !textfield.field?.data?.isSameLine }"
        [parentStore]="parentStore"
        [parentTab]="parentTab" />
    }
    <iu-text-field-ui
      #calculatedIndicatorRef
      [colorIndicatorCondition]="calculatedIndicator?.value >= 0"
      [container]="this"
      [fieldType]="'I'"
      [label]="calculatedIndicator?.label"
      [loadingAnimationTimeout]="1250"
      [value]="calculatedIndicator?.displayValue"
      [withColorIndicator]="true" />
  </section>
  <!-- Section - Text fields -->
</div>
